export const FILTERSET_EDITOR_TYPE_ALLOCATION_RULE = 'FILTERSET_EDITOR_TYPE_ALLOCATION_RULE';
export const FILTERSET_EDITOR_TYPE_ORDER_FILTER = 'FILTERSET_EDITOR_TYPE_ORDER_FILTER';
